
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class IconCreateShipment extends Vue {
  @Prop({ default: 24 }) size!: number;
}
